exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "html{height:100%}body{height:100%;color:#000 !important}#root{height:100%}", "",{"version":3,"sources":["/home/ubuntu/workspace/Locus_fr-tracking-oms-fe_master/fr-tracking-oms-fe/src/app.css"],"names":[],"mappings":"AAAA,KACE,WAAA,CAGF,KACE,WAAA,CACA,qBAAA,CAGF,MACE,WAAA","file":"app.css","sourcesContent":["html {\n  height: 100%;\n}\n\nbody {\n  height: 100%;\n  color: #000000 !important;\n}\n\n#root {\n  height: 100%;\n}\n"]}]);
// Exports
exports.locals = {
	"root": "root"
};